export default function GameLoad() {

    return (
        <div className="loadContent">
            <div>
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="loadContentText">
                    กำลังโหลดข้อมูลเกม...
                </div>
            </div>
            <br />
        </div>
    );
}